import { FormControl, InputLabel, Select, MenuItem } from "@mui/material";
import { DefaultDatePickerInput } from "../../../../../../common/components/default_date_picker_input";

import CascateList from "../../../../../../common/components/cascate_list";
import DefaultInput from "../../../../../../common/components/default_input";
import PrimaryButton from "../../../../../../common/components/primary_button";

/**
 * Header
 */

type Props = {
  data: Date | null;
  localizacao: string | null;
  status: number;
  onDataChange: (value: Date | null) => void;
  onLocalizacaoChange: (value: string | null) => void;
  onStatusChange: (value: number) => void;
  onClear: () => void;
};

export const Header = ({
  data,
  localizacao,
  status,
  onDataChange,
  onLocalizacaoChange,
  onStatusChange,
  onClear,
}: Props) => {
  return (
    <CascateList title="Pesquisar" defaultOpen>
      <div className="w-full flex flex-col gap-6 items-center justify-center">
        <div className="w-full grid gap-6 grid-cols-1 md:grid-cols-2 lg:grid-cols-3 grid-flow-row-dense">
          <div className="w-full col-span-3 grid grid-cols-3 gap-6">
            <div className="col-span-1">
              <DefaultDatePickerInput
                label='Data'
                value={data}
                onChange={onDataChange}
              />
            </div>

            <div className="col-span-2">
              <DefaultInput
                label="Localização"
                name="localizacao"
                value={localizacao}
                onChangeValue={onLocalizacaoChange}
              />
            </div>
          </div>

          <div className="flex col-span-1 md:col-span-2 lg:col-span-1 gap-1">
            <FormControl size="small" fullWidth>
              <InputLabel id="status">Status</InputLabel>
              <Select
                labelId="status"
                label="Status"
                value={status}
                onChange={e => onStatusChange(Number(e.target.value))}>
                <MenuItem value={2}>Todas</MenuItem>
                <MenuItem value={0}>Verificação Não Iniciada</MenuItem>
                <MenuItem value={3}>Verificação Iniciada</MenuItem>
                <MenuItem value={1}>Encerrada</MenuItem>
              </Select>
            </FormControl>
          </div>
        </div>

        <div className="w-full flex flex-col items-end">
          <div className="w-[7.5rem]">
            <PrimaryButton buttonColor="yellow" onClick={onClear}>
              Limpar
            </PrimaryButton>
          </div>
        </div>
      </div>
    </CascateList>
  );
}